import React, { Component } from 'react';
import { Form, Grid, Divider } from '@solarwindscloud/nighthawk-ui';
import { isEmailValid } from '@solarwindscloud/swicus-validation';
import { LinkedButton, EmailInput, ErrorMessage } from '../../../../components';
import styles from './ResetPasswordForm.module.scss';
import PropTypes from 'prop-types';
import SubmitButton from '../../../../components/SubmitButton/SubmitButton';
import { ROUTES } from '@solarwindscloud/sso-nighthawk-shared';

export default class ResetPasswordForm extends Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    email: PropTypes.string.isRequired,
    errors: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleEmailError: PropTypes.func.isRequired,
    handleChangeEmail: PropTypes.func.isRequired,
    renderSuccess: PropTypes.bool,
  };

  render() {
    return this.renderFormBody();
  }

  renderFormBody() {
    const { errors, handleSubmit } = this.props;
    return (
      <>
        <Form onSubmit={handleSubmit} method="POST" error={this.hasFormError()} className={styles.formContainer}>
          {this.renderEmailInput()}
          {this.renderButtons()}
        </Form>
        <Divider hidden section />
        {this.renderResetPasswordErrorIfNecessary(errors)}
        {this.renderInvalidResetPasswordTokenErrorIfNecessary(errors)}
      </>
    );
  }

  renderButtons() {
    return (
      <Grid>
        <Grid.Column>
          {!this.props.renderSuccess && (
            <SubmitButton disabled={this.isSubmitDisabled()} loading={this.props.isLoading}>
              Recover password
            </SubmitButton>
          )}
          <LinkedButton link={ROUTES.LOGIN} label="Return to Login" external />
        </Grid.Column>
      </Grid>
    );
  }

  renderEmailInput() {
    const { email, handleChangeEmail, handleEmailError, errors, renderSuccess } = this.props;
    return (
      <EmailInput
        onChange={handleChangeEmail}
        onError={handleEmailError}
        hasError={!!errors.email}
        value={email}
        placeholder={'Email address'}
        errorMessage={'Enter a valid email address'}
        autoFocus
        allowEmpty
        disabled={renderSuccess}
      />
    );
  }

  renderInvalidResetPasswordTokenErrorIfNecessary(errors) {
    if (errors.invalidResetPasswordToken && !this.props.renderSuccess) {
      return <ErrorMessage message="Your password reset link is invalid or has expired." renderCloseMessage />;
    }
  }

  renderResetPasswordErrorIfNecessary(errors) {
    return (
      errors.resetPassword && (
        <ErrorMessage message={errors.resetPassword} className={styles.errorMessage} renderCloseMessage />
      )
    );
  }

  isSubmitDisabled() {
    return this.isEmptyEmailInput() || !isEmailValid(this.props.email) || this.props.isLoading;
  }

  isEmptyEmailInput() {
    return this.props.email.length === 0;
  }

  hasFormError() {
    const errors = this.props.errors;
    return Object.keys(errors).some(k => errors[k]);
  }
}
